import withStyles from "@mui/styles/withStyles";
import React from "react";
import iconBlueClose from "../../assets/images/icon_blue_close.svg";
import EmailInput from "../shared/EmailInputWhite";
import arrow from "../../assets/images/arrow-left.svg";
import sendEmailToBoss from "../../assets/images/sendEmailToBoss.png";
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const topOffset = "10%";
const button = {
  boxShadow: "0px 3px 20px #00000026",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
  padding: "16px 30px",
  color: "#FFFFFF",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "80%",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
  },
  kyteTecRegistration: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #a5d6e7)",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    maxHeight: "100vh",
    overflowY: "auto",
  },
  whiteText: {
    color: "white",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "200",
    fontSize: "27px",
    padding: "21px 0px",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
    filter:
      "invert(100%) sepia(84%) saturate(2%) hue-rotate(149deg) brightness(103%) contrast(101%)",
  },
  block: block,
  buttonDanger: {
    ...button,
    backgroundColor: "#ffab9d",
    border: "none",
    maxHeigth: "40px",
    width: "100%",
  },
  buttonInfo: {
    ...button,
    backgroundColor: "white",
    color: "#4396e6",
  },
});
function KyteTecEmailRegistrationContent({
  classes,
  setShowKyteTecEmailModal,
  setShowPurchaseModal,
  submitHandler,
}) {
  useMakeScrollable(".scrollable-modal");
  const closeModal = () => {
    setShowKyteTecEmailModal(false);
    setShowPurchaseModal(false);
  };
  return (
    <div style={{ position: "relative" }} className={classes.block}>
      <div className="scrollable-modal">
        <img
          className={classes.closeIcon}
          src={iconBlueClose}
          alt="Close register to kyte tec modal"
          onClick={(e) => closeModal()}
        />
        <div>
          <div className={classes.whiteText}>
            <div
              style={{
                fontSize: "25px",
              }}
            >
              <p>Jetzt deinem Chef das Anmeldeformular schicken.</p>
            </div>
            <div>
              <img src={sendEmailToBoss} alt="send email" />
            </div>
          </div>
          <div
            style={{
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <form onSubmit={submitHandler}>
              <EmailInput />
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <button type="submit" className={classes.buttonDanger}>
                  Versenden
                </button>
              </div>
            </form>
          </div>
          <div style={{ margin: "auto" }}>
            <div
              style={{
                marginBottom: "20px",
              }}
            ></div>
            <div
              style={{
                marginTop: "75px",
                marginBottom: "90px",
              }}
            >
              <div
                className={classes.buttonInfo}
                style={{ alignItems: "center" }}
                onClick={(e) => setShowKyteTecEmailModal(false)}
              >
                <img
                  alt="arrow"
                  style={{
                    filter:
                      "invert(60%) sepia(22%) saturate(6078%) hue-rotate(186deg) brightness(95%) contrast(90%)",
                    position: "absolute",
                    left: "20%",
                  }}
                  src={arrow}
                />
                <span>Zurück</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(KyteTecEmailRegistrationContent);
